/**
 * WorkOS client configuration
 */

import { env } from './env';

export const workosConfig = {
  clientId: env.workos.clientId,
  apiKey: env.workos.apiKey,
  redirectUri: env.workos.redirectUri,
  // Default organization settings
  organizationId: undefined as string | undefined,
};

/**
 * Get the WorkOS sign-in URL via backend
 * The backend handles all WorkOS interaction for security
 */
export const getSignInUrl = (returnTo?: string) => {
  const params = new URLSearchParams({
    ...(returnTo && { returnTo }),
  });

  // Use backend auth endpoint which handles WorkOS redirect
  return `${env.api.url}/auth/login${params.toString() ? `?${params.toString()}` : ''}`;
};

/**
 * Get the WorkOS sign-up URL via backend
 * The backend handles all WorkOS interaction for security
 */
export const getSignUpUrl = (returnTo?: string) => {
  const params = new URLSearchParams({
    ...(returnTo && { returnTo }),
    screen_hint: 'sign-up',
  });

  // Use backend auth endpoint which handles WorkOS redirect
  return `${env.api.url}/auth/login${params.toString() ? `?${params.toString()}` : ''}`;
};

/**
 * Parse the state parameter from WorkOS callback
 */
export const parseCallbackState = (state: string | null): { returnTo?: string } => {
  if (!state) return {};

  try {
    return JSON.parse(atob(state));
  } catch {
    return {};
  }
};
